/// Uwaga: Scisle powiazany kod jest w `OTP.Domain.WorkflowState`
export class WorkflowTypes {
  public static readonly OTP_NORMAL = 0;
  public static readonly OTP_RETENTION = 1;
  public static readonly LEN_NORMAL = 2; // Start procesu przez integratora (starting-form)
  public static readonly LEN_RETENTION = 3;
  public static readonly LEN_PAYTREE_NORMAL = 4; //Start procesu przez formularz openy
  public static readonly LEN_PAYTREE_RETENTION = 5;

  public static readonly OTP_FLEXI_NORMAL = 6;
  public static readonly OTP_FLEXI_RETENTION = 8;
  public static readonly OTP_TRASTI_NORMAL = 9;

  public static IsRetention(type: number | null): boolean {
    return this.OTP_RETENTION === type || this.LEN_RETENTION === type || this.LEN_PAYTREE_RETENTION === type || this.OTP_FLEXI_RETENTION === type;
  }

  public static isNormal(type: number | null): boolean {
    return this.OTP_NORMAL === type || this.LEN_NORMAL === type || this.LEN_PAYTREE_NORMAL === type || this.OTP_FLEXI_NORMAL  === type || this.OTP_TRASTI_NORMAL === type;
  }

  public static isFlexi(type: number | null): boolean {
    return this.OTP_FLEXI_NORMAL === type || this.OTP_FLEXI_RETENTION === type;
  }
}